














import { Component, Mixins, Emit } from "vue-property-decorator";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import { UserSelectableMixin } from "./mixins/";
import { FixedLoading } from "../../system";

@Component({
  components: {
    OptionListBoxSelector,
    FixedLoading,
  },
})
export default class UserListSelector extends Mixins(UserSelectableMixin) {
  scrollIntoView(): void {
    (this.$refs.selector as OptionListBoxSelector).scrollIntoView();
  }

  @Emit()
  dblclick(e: PointerEvent): void {}
}
